/**
 * Site Types Catalog Object
 */
export const LineDirection = {
  Horizontal: 1,
  Vertical: 2,
};

export const FlowDirection = {
  None: 0,
  StartToEnd: 1,
  EndToStart: 2,
};

export const EssState = {
  Charging: 1,
  Discharging: 2,
  Idle: 3,
};
